import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/store'

import Login from '@/views/Login'

import Error404 from '@/views/Error404'

Vue.use(VueRouter)

function lazyLoadAdmin(view){
  return() => import(`@/views/admin/${view}`)
}
function lazyLoadUser(view){
  return() => import(`@/views/user/${view}`)
}

const router = new VueRouter({
	routes: [
		{
			path: '/Home',
			component: lazyLoadAdmin('Home'),
			name: 'Home',
			meta: { 
				title: 'CETABA',
				requiresAuthentication: true
			}
		},
		{
			path: '/Cursos',
			component: lazyLoadAdmin('Curso'),
			name: 'Cursos',
			meta: { 
				title: 'Cursos',
				requiresAuthentication: true
			},
			children: [
				{
					path: 'Lista',
					component: lazyLoadAdmin('Cursos'),
					name: 'GerenciarCursos',
					meta: { 
						title: 'Cursos',
						requiresAuthentication: true
					}
				},
				{
					path: ':id(\\d+)',
					component: lazyLoadAdmin('Aulas'),
					name: 'Aulas',
					meta: { 
						title: 'Aulas',
						requiresAuthentication: true
					}
				}
			]
		},
		{
			path: '/Users',
			component: lazyLoadAdmin('User'),
			name: 'Users',
			meta: { 
				title: 'Usuários',
				requiresAuthentication: true
			},
			children: [
				{
					path: 'Lista',
					component: lazyLoadAdmin('Users'),
					name: 'GerenciarUsers',
					meta: { 
						title: 'Usuários',
						requiresAuthentication: true
					},
				},
				{
					path: ':id(\\d+)',
					component: lazyLoadAdmin('UserCursos'),
					name: 'UserCursos',
					meta: {
						title: 'Cursos',
						requiresAuthentication: true
					}
				},
			]
		},
		{
			path: '/MeusCursos',
			component: lazyLoadUser('MeusCursos'),
			name: 'MeusCursos',
			meta: { 
				title: 'Meus cursos',
				requiresAuthentication: true
			},
			children: [
				{
					path: 'Lista',
					component: lazyLoadUser('MeusCursosLista'),
					name: 'MeusCursosLista',
					meta: { 
						title: 'Meus cursos',
						requiresAuthentication: true
					},
				},
				{
					path: ':id(\\d+)',
					component: lazyLoadUser('MeuCurso'),
					name: 'MeuCurso',
					meta: {
						title: 'Meu curso',
						requiresAuthentication: true
					}
				},
			]
		},
		{
			path: '/MeusDados',
			component: lazyLoadUser('MeusDados'),
			name: 'MeusDados',
			meta: { 
				title: 'Meus dados',
				requiresAuthentication: true
			},
		},
		{
			path: '/login',
			component: Login,
			name: 'Login',
			meta: { 
				title: 'Login - CETABA',
				isAuthenticated: true 
			}
		},
		{ 
			path: '/', 
			redirect: { name: 'Home' }
		},
		{
			path: '*',
			component: Error404,
			meta: { 
				title: 'Página não encontrada'
			}
		}
	]
})

router.beforeEach((to, from, next) => {
	const authenticated = store.state.authenticated
	if (to.matched.some(rota => rota.meta.requiresAuthentication)) {
		if (!authenticated) {
			next({
				name: 'Login',
				query: { redirect: to.fullPath }
			})
			return
		}
	}
	if (to.matched.some(rota => rota.meta.isAuthenticated)) {
		if (authenticated) {
			next({
				name: 'Home'
			})
			return
		}
	}
	if (to.matched.some(rota => rota.meta.bloqueiaNavegacao)) {
		if (to.meta.bloqueiaNavegacao === true) {
			next(false)
			return
		}
	}
	next()
})

router.afterEach((to) => {
	Vue.nextTick(() => {
			document.title = to.meta.title || 'Cetaba';
	});
});

export default router